export interface AttentionCompany {
  attentionCompanyType?: string;
  email?: string;
  fullName?: string;
  privacyPolicy?: boolean;
  message?: string;
  phone?: string;
  companyName?: string;
}

export enum AttentionCompanySubjectType {
  QT_SAMPLE = 'QT_SAMPLE',
  QT_QUESTION = 'QT_QUESTION',
  QT_ATTENTION = 'QT_ATTENTION'
}
